<div class="ui-ErrorPagesSample-wrapper">
  <xpo-error-pages [type]="403">
    <xpo-error-pages-title>
      <h1>Forbidden</h1>
    </xpo-error-pages-title>

    <xpo-error-pages-description>
      <p>Sorry, you don't have access to the Tariff Management application.</p>
    </xpo-error-pages-description>

    <xpo-error-pages-image>
      <img src="./assets/images/ErrorPage_404_img.png" alt="Forbidden" />
    </xpo-error-pages-image>
  </xpo-error-pages>
</div>
